import { AxiosError } from "axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchModuleSettings,
  changeModuleSettings,
} from "src/Pages/Company/OrganizationStructure/api";
import { retryQueryConfig } from "src/Pages/Company/OrganizationStructure/config/retryQueryConfig";
import {
  IModuleSettings,
  TModuleSettingsPayload,
} from "src/Pages/Company/OrganizationStructure/ModuleSettings/moduleSettings.models";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

const moduleSettingsQueryKey = "module-settings";

export const useFetchModuleSettings = (companyId: string) =>
  useQuery<IModuleSettings, AxiosError>({
    enabled: !!companyId,
    queryKey: [moduleSettingsQueryKey, companyId],
    queryFn: async ({ signal }) => fetchModuleSettings(companyId, { signal }),
    ...retryQueryConfig,
  });

export const useChangeModuleSettings = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TModuleSettingsPayload) =>
      changeModuleSettings(companyId, payload),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zapisano dane"), "success");
      queryClient.invalidateQueries({
        queryKey: [moduleSettingsQueryKey, companyId],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się zapisać danych"), "error");
    },
  });
};
